import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ViewPicker
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/ViewPicker';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const styles = () => ({
  root: {},
});

const OnboardingView = ({
  className,
  classes,
}) => {
  const { householdResource } = useSimpleHousehold();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <ViewPicker householdResource={householdResource} />
    </Box>
  );
};

OnboardingView.defaultProps = {
  className: '',
};

OnboardingView.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OnboardingView);
